var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCitiisTechIntegration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 251 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1,.cls-3{fill-rule:evenodd;}.cls-4,.cls-5,.cls-3{stroke-miterlimit:10;}.cls-4,.cls-3{fill:none;stroke:#fff;stroke-width:2.5px;}.cls-5{fill:url(#linear-gradient);filter:url(#drop-shadow-1);stroke:#93cc82;stroke-width:2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 39,
    y1: 189.07,
    x2: 216.92,
    y2: 4.13,
    gradientTransform: "translate(0 16.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93c954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4eb7be"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 0,
    y: 0,
    width: 251,
    height: 248,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.79,
    dy: 3.79
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.79
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#010101",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HEADER"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.93,230.62h114.3c61.45,0,111.27-48.96,111.27-109.35V8.97s-114.29,0-114.29,0c-61.46,0-111.28,48.96-111.28,109.34v112.31Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "23.49 140.92 49.12 140.38 61.54 119.11 48.59 97.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "61.54 119.11 87.14 118.56 99.02 97.02 123.95 97.16 136.84 75.46 161.68 75.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "49.12 140.38 61.94 162.19 86.19 162.43 99.09 141 87.14 118.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "99.09 141 124.64 140.31 136.52 118.93 123.95 97.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 86.19,
    y1: 162.43,
    x2: 98.8,
    y2: 184.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "124.64 140.31 137.58 162.25 123.98 184.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 136.84,
    y1: 75.46,
    x2: 124.96,
    y2: 53.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.72,51.92c1.35,0,2.57-.55,3.45-1.43.88-.88,1.43-2.1,1.43-3.45s-.55-2.57-1.43-3.45c-.88-.88-2.1-1.43-3.45-1.43s-2.57.55-3.45,1.43c-.88.88-1.43,2.1-1.43,3.45s.55,2.57,1.43,3.45c.88.88,2.1,1.43,3.45,1.43h0ZM126.84,52.16c-1.31,1.31-3.12,2.12-5.12,2.12s-3.81-.81-5.12-2.12c-1.31-1.31-2.12-3.12-2.12-5.12s.81-3.81,2.12-5.12c1.31-1.31,3.12-2.12,5.12-2.12s3.81.81,5.12,2.12c1.31,1.31,2.12,3.12,2.12,5.12s-.81,3.81-2.12,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.72,193.71c1.35,0,2.57-.55,3.45-1.43.88-.88,1.43-2.1,1.43-3.45s-.55-2.57-1.43-3.45c-.88-.88-2.1-1.43-3.45-1.43s-2.57.55-3.45,1.43c-.88.88-1.43,2.1-1.43,3.45s.55,2.57,1.43,3.45c.88.88,2.1,1.43,3.45,1.43h0ZM126.84,193.94c-1.31,1.31-3.12,2.12-5.12,2.12s-3.81-.81-5.12-2.12c-1.31-1.31-2.12-3.12-2.12-5.12s.81-3.81,2.12-5.12c1.31-1.31,3.12-2.12,5.12-2.12s3.81.81,5.12,2.12c1.31,1.31,2.12,3.12,2.12,5.12s-.81,3.81-2.12,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.17,97.14c1.35,0,2.57-.55,3.45-1.43.88-.88,1.43-2.1,1.43-3.45s-.55-2.57-1.43-3.45c-.88-.88-2.1-1.43-3.45-1.43s-2.57.55-3.45,1.43c-.88.88-1.43,2.1-1.43,3.45s.55,2.57,1.43,3.45c.88.88,2.1,1.43,3.45,1.43h0ZM51.29,97.38c-1.31,1.31-3.12,2.12-5.12,2.12s-3.81-.81-5.12-2.12c-1.31-1.31-2.12-3.12-2.12-5.12s.81-3.81,2.12-5.12c1.31-1.31,3.12-2.12,5.12-2.12s3.81.81,5.12,2.12c1.31,1.31,2.12,3.12,2.12,5.12s-.81,3.81-2.12,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.3,116.71l-6.59-.55.23-2.69,4.68.39,4.83-10.65.7-.13c2.64-.47,5.18-1.27,7.57-2.39l.64-.3,10.1,5.89,5.22-4.39-4.11-10.93.41-.58c1.52-2.18,2.76-4.57,3.67-7.11l.24-.67,11.32-2.98.57-6.77-10.66-4.83-.13-.7c-.48-2.65-1.3-5.21-2.43-7.62l-.3-.64,5.88-10.09-4.41-5.2-10.94,4.12-.58-.4c-2.16-1.49-4.53-2.71-7.06-3.62l-.67-.24-2.98-11.31-6.67-.56-4.83,10.65-.7.13c-2.64.47-5.19,1.28-7.57,2.39l-.64.3-10.1-5.88-5.22,4.39,2.08,5.53-2.53.95-2.75-7.32,8.14-6.85,10.53,6.13c2.19-.97,4.5-1.69,6.88-2.17l5.03-11.1,10.48.88,3.11,11.79c2.27.87,4.43,1.98,6.42,3.29l11.41-4.29,6.88,8.11-6.13,10.52c.99,2.21,1.73,4.54,2.21,6.93l11.11,5.04-.89,10.57-11.8,3.11c-.88,2.28-2,4.45-3.34,6.47l4.29,11.4-8.14,6.85-10.53-6.14c-2.19.97-4.5,1.7-6.88,2.17l-5.03,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.73,84.58c-6.5-.55-11.34-6.28-10.79-12.77s6.28-11.34,12.78-10.79c6.5.55,11.34,6.28,10.79,12.78s-6.28,11.34-12.78,10.79ZM173.48,63.71c-5.01-.42-9.43,3.31-9.86,8.33-.42,5.01,3.31,9.43,8.33,9.85,5.01.42,9.43-3.31,9.86-8.32.42-5.01-3.31-9.43-8.33-9.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "159.69 58.11 158.16 55.88 160.43 54.36 161.93 56.6 159.69 58.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.81,94.81l-.8-2.58,1.27-.46,1.32-.29.8,2.58-1.32.29-.29-1.32.28,1.32-1.27.46ZM183.51,92.23l-1.46-2.22,1.1-.74,1.49,2.26-1.13.7ZM189.08,87.85l-2.08-1.73,1.72-2.06,2.11,1.65-1.75,2.15ZM193.06,81.83l-2.53-.87.43-1.26,2.56.88-.46,1.25ZM194.79,75.02l-2.69-.23.22-2.65,2.61.07-.14,2.8ZM191.77,68.56l-.68-2.58,2.51-.79.79,2.68-2.61.69ZM189.29,62.7l-.65-1.18-.82-1.08,2.23-1.51.95,1.29.65,1.18-2.37,1.31ZM185.49,57.9l-1.08-.72.7-1.16.84-1.06-.84,1.06.85-1.05,1.02.8-1.49,2.13ZM165,54.88l-.84-2.56,1.52-.58,1.32-.29.57,2.64-1.32.29-1.26.5ZM180.22,54.59l-1.32-.3-1.25-.51.76-2.59,1.25.51-.5,1.25.51-1.25,1.32.3-.76,2.59ZM171.12,53.37l-.02-2.69,1.6-.08,1.35.11-.23,2.69-1.35-.11-1.35.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.23 95.04 169.51 94.81 169.74 92.12 172.43 92.35 172.23 95.04"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitiisTechIntegration);
export default __webpack_public_path__ + "static/media/citiis_tech_integration.485a79d7a2849ef12e7eadffeed7674a.svg";
export { ForwardRef as ReactComponent };